import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { DateLength, Intent, Mood } from '@/api/types';

interface MatchPrefsState {
  mood: Mood | null;
  intent: Intent;
  /** v6: last Date Night length picked on Home. */
  dateLength: DateLength;
  setMood: (m: Mood) => void;
  setIntent: (i: Intent) => void;
  setDateLength: (l: DateLength) => void;
}

const safeStorage = createJSONStorage(() => {
  try {
    const s = window.localStorage;
    const k = '__popin_probe__';
    s.setItem(k, '1');
    s.removeItem(k);
    return s;
  } catch {
    const mem = new Map<string, string>();
    return {
      getItem: (k: string) => mem.get(k) ?? null,
      setItem: (k: string, v: string) => void mem.set(k, v),
      removeItem: (k: string) => void mem.delete(k),
    };
  }
});

/** Remembered per-device convenience: last mood/intent picked on Home. */
export const useMatchPrefs = create<MatchPrefsState>()(
  persist(
    (set) => ({
      mood: null,
      intent: 'talk',
      dateLength: 30,
      setMood: (mood) => set({ mood }),
      setIntent: (intent) => set({ intent }),
      setDateLength: (dateLength) => set({ dateLength }),
    }),
    { name: 'popin.matchPrefs', storage: safeStorage },
  ),
);
